module.exports = {
  title: 'Myths of The Matrix', // Required
  author: 'Mark Ennis, Manpreet Parmar, Shahzaib Shaikh, Andrew Takahashi', // Required
  description: '',
  primaryColor: '#008F11', // Required
  showHeaderImage: true,
  showShareButtons: false,
  postsPerPage: 8, // Required
  social: {
    website: '',
    github: '',
    twitter: '',
    linkedin: '',
  },
  pathPrefix: '',
  siteUrl: 'https://mythofthematrix.space/',
};
